import { useState } from "react";

import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";

import { Organisation, User } from "../../../types";
import TableViewShell from "../../../components/views/table-view-shell";
import TeamsTableRow from "./teams-table-row";

interface TeamsTableProps {
  filteredTeams: Organisation[];
  unfilteredTeamsCount: number;
  users: Record<string, User>;
  canEditOrgs: string[]
}

const TeamsTable: React.FC<TeamsTableProps> = ({
  filteredTeams,
  unfilteredTeamsCount,
  users,
  canEditOrgs,
}) => {
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const headerLabelSx = { fontSize: "0.875rem" };
  const headerCellSx = { py: 0.5, fontSize: "0.875rem", whiteSpace: "nowrap" };

  const sortedTeams = [...filteredTeams].sort((a, b) => {
    const comparison = a.name.localeCompare(b.name, undefined, {
      sensitivity: "base",
    });

    return sortOrder === "asc" ? comparison : -comparison;
  });

  const handleNameSort = () => {
    setSortOrder((currentOrder) =>
      currentOrder === "asc" ? "desc" : "asc",
    );
  };

  const columns = (
    <colgroup>
      <col style={{ width: 240 }} />
      <col style={{ width: 220 }} />
      <col />
      <col style={{ width: 160 }} />
    </colgroup>
  );

  return (
    <TableViewShell
      shownCount={sortedTeams.length}
      totalCount={unfilteredTeamsCount}
      columns={columns}
      headerAriaLabel="organisation table header"
      bodyAriaLabel="organisation table"
      header={
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={headerCellSx}>
              <TableSortLabel
                active
                direction={sortOrder}
                onClick={handleNameSort}
                sx={headerLabelSx}
              >
                Name
              </TableSortLabel>
            </TableCell>
            <TableCell align="left" sx={headerCellSx}>Meeting Layouts</TableCell>
            <TableCell align="left" sx={headerCellSx}>Members</TableCell>
            <TableCell align="right" sx={headerCellSx}></TableCell>
          </TableRow>
        </TableHead>
      }
      body={
        <TableBody>
          {sortedTeams.map((team) => {
            return (
              <TeamsTableRow
                key={team.organisationId}
                team={team}
                users={users}
                showManageButton={canEditOrgs.includes(team.organisationId)}
              />
            );
          })}
          {sortedTeams.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} sx={{ py: 2 }}>
                <Typography variant="body1">No teams found</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      }
    />
  );
};

export default TeamsTable;

